import React, { useState } from 'react';
import { Filter as FilterIcon } from 'lucide-react';

const FilterSort = ({ onFilterSort, t }) => {
  const [priceRange, setPriceRange] = useState({ min: '', max: '' });
  const [sortBy, setSortBy] = useState('departureTime');
  const [sortOrder, setSortOrder] = useState('asc');

  const handleApply = () => {
    onFilterSort({ priceRange, sortBy, sortOrder });
  };

  return (
    <div className="bg-white rounded-lg shadow-md p-4 mt-4">
      <h3 className="text-lg font-semibold mb-4 flex items-center text-blue-900">
        <FilterIcon className="mr-2" />
        {t.filterAndSort}
      </h3>
      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            {t.priceRange}
          </label>
          <div className="flex space-x-2">
            <input
              type="number"
              placeholder={t.min}
              value={priceRange.min}
              onChange={(e) => setPriceRange(prev => ({ ...prev, min: e.target.value }))}
              className="w-full p-2 border rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
            <input
              type="number"
              placeholder={t.max}
              value={priceRange.max}
              onChange={(e) => setPriceRange(prev => ({ ...prev, max: e.target.value }))}
              className="w-full p-2 border rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div>
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            {t.sortBy}
          </label>
          <select
            value={sortBy}
            onChange={(e) => setSortBy(e.target.value)}
            className="w-full p-2 border rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          >
            <option value="departureTime">{t.departureTime}</option>
            <option value="arrivalTime">{t.arrivalTime}</option>
            <option value="price">{t.price}</option>
          </select>
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            {t.sortOrder}
          </label>
          <select
            value={sortOrder}
            onChange={(e) => setSortOrder(e.target.value)}
            className="w-full p-2 border rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          >
            <option value="asc">{t.ascending}</option>
            <option value="desc">{t.descending}</option>
          </select>
        </div>
        <button
          onClick={handleApply}
          className="w-full bg-[#9a55f4] text-white py-2 px-4 rounded-md hover:bg-[#8645e0] transition-colors"
        >
          {t.apply}
        </button>
      </div>
    </div>
  );
};

export default FilterSort;